import config from 'config';

const LOAD_LAYOUT = 'common/media/LOAD_LAYOUT';
const LOAD_LAYOUT_SUCCESS = 'common/media/LOAD_LAYOUT_SUCCESS';
const LOAD_LAYOUT_FAIL = 'common/media/LOAD_LAYOUT_FAIL';
const SET_LAYOUT = 'common/media/SET_LAYOUT';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_LAYOUT:
      return {
        ...state,
        [action.path]: {
          ...state[action.path],
          loading: true
        }
      };
    case LOAD_LAYOUT_SUCCESS:
      return {
        ...state,
        [action.path]: {
          ...state[action.path],
          loading: false,
          loaded: true,
          layout: action.result.layout
        }
      };
    case LOAD_LAYOUT_FAIL:
      return {
        ...state,
        [action.path]: {
          ...state[action.path],
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    case SET_LAYOUT: {
      return {
        ...state,
        [action.path]: {
          ...state[action.path],
          loading: false,
          loaded: true,
          layout: action.layout
        }
      };
    }
    default:
      return state;
  }
}

export function loadLayout(path) {
  return {
    types: [LOAD_LAYOUT, LOAD_LAYOUT_SUCCESS, LOAD_LAYOUT_FAIL],
    promise: (client) => client.get(`${config.api.common.layout.loadLayout}`),
    path
  }
}

export function setLayout(path, layout) {
  return {
    type: SET_LAYOUT,
    path,
    layout
  }
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/layout.js